import React, { useEffect, useState } from 'react';
import RichTextFullComp from '../../../../../MySections/TextEditor/RichTextFull';

const AccordProdTextArea = (props) => {

    const [prodName, setProdName] = useState();

    useEffect(() => {
        setProdName(props.prodTxtVal);
        // console.log(props.prodTxtVal);
        // setProdName(props.prodTxtVal);
    }, [])
    return (
        <div className={`${props.clss ? props.clss : "prodFirst"}`}>
            <div className={"col-md-3 onRight noPadding"}>
                <label className={""}>{props.headI}</label>
            </div>
            <div className={"col-md-9 onRight noPadding"}>
                <RichTextFullComp firstText={prodName}
                    hideButtons={true}
                    height={"100px"}
                    padding={"5px"}
                    // onBlur={(content) => props.setProdItm(props.index, props.proIndex, content)}
                    saveEditorTxt={(content) => { setProdName(content); props.setProdItm(props.index, props.proIndex, content) }} />
            </div>
            {/* 
            

            <textarea ros={"4"} placeholder={props.headI}
                onChange={(e) => setProdName(e.target.value)}
                onBlur={(e) => props.setProdItm(props.index, props.proIndex, e.target.value)}
                value={prodName}
            ></textarea> */}
        </div>

    )
}

export default AccordProdTextArea;



{/* <div className={`${props.clss ? props.clss : "prodFirst"}`}>
<label className={"txtARLbl"}>{props.headI}</label>
<textarea ros={"4"} placeholder={props.headI}
    onChange={(e) => setProdName(e.target.value)}
    onBlur={(e) => props.changeProdProducts(props.index, props.proIndex, e.target.value)}
    defaultValue={prodName}></textarea>
</div> */}
